import { AxiosRequestConfig } from 'axios';
import { AccessTokenContext, AxiosRequestConfigWithTokenConfig, Permission } from '../types';
import TokenService from './TokenService';

export async function injectTokenToConfig(
  config: AxiosRequestConfig,
  context: AccessTokenContext,
  permissions?: Permission[],
) {
  const configWithToken: AxiosRequestConfigWithTokenConfig = { ...config };

  configWithToken.accessTokenContext = context;
  const token = await TokenService.getToken(context, permissions);

  if (!token) {
    throw new Error(`No token assumed for context ${context}`);
  }

  if (!configWithToken.headers) {
    configWithToken.headers = {};
  }

  configWithToken.headers['Authorization'] = `Bearer ${token.token}`;

  return configWithToken;
}
